import { http } from './request'

/** 与后端 SystemConfigPanelPublicResult 一致；GET 免登录 */
export interface SysPublicBranding {
  systemName: string
  systemDescription: string
  systemLogo: string
  copyrightText: string
}

export async function fetchSysPublicBranding(): Promise<SysPublicBranding> {
  return http.get<SysPublicBranding>('/biz/config/systemPanel/public')
}
